import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import Message from 'components/Message';
import NestedLink from 'components/NestedLink';
import Typography from 'components/Typography';
import VisualTileSkeleton from 'components/VisualTileSkeleton';

import { PlaylistForListFragment } from 'graphql/generated/graphql';

import analytics from 'helpers/analytics';

import { useTracking } from 'hooks/useTracking';

import variables from 'styles/base/variables_exported.module.scss';

import { getPlaylistImage, getPlaylistName } from '../hooks/helpers';
import './style.scss';

interface IProps {
  playlist: PlaylistForListFragment;
  trackingCategory?: string;
}

const PlaylistTile = ({ playlist, trackingCategory = 'playlist' }: IProps) => {
  const { formatMessage, locale } = useIntl();

  const playlistName = getPlaylistName(playlist, formatMessage);

  const { trackContentInteraction } = useTracking();

  const trackClick = useCallback(
    (category: string) => {
      const label = `${category}_${playlist.id}`;

      analytics.track('click-playlist', {
        category,
        label,
      });

      trackContentInteraction('click', category, label);
    },
    [playlist.id, trackContentInteraction],
  );

  return (
    <NestedLink
      onClick={() => trackClick(trackingCategory)}
      to={`/playlists/${playlist.id}`}
      className="PlaylistTile"
    >
      <VisualTileSkeleton
        src={getPlaylistImage(playlist)}
        alt={playlistName}
        height={variables.tileSize}
        width={variables.tileSize}
      />

      <div className="PlaylistTile__content">
        <Typography variant="h4" language={locale}>
          {playlistName}
        </Typography>
        <div>
          <Typography variant="small-thin">
            <Message
              message={{
                id: 'SM0123.My Playlist_Audio number',
                values: { count: playlist.stories.totalCount },
              }}
            />
          </Typography>
        </div>
      </div>
    </NestedLink>
  );
};

export default PlaylistTile;
